import {ServerData, ServerGameFeatures} from '@fantasmagames/prototype/src/data/ServerData';
import {ServerAvalancheReelsRound} from '@fantasmagames/prototype/src/reels/ServerAvalancheReelsRound';
import {ServerCheats} from '@fantasmagames/prototype/src/cheats/ServerCheats';

export class Server {
	protected _data: ServerData;
	protected _lastRound: ServerAvalancheReelsRound;

	protected _cheats: ServerCheats;

	protected _history: ServerAvalancheReelsRound[] = [];

	protected _mfsRounds: ServerAvalancheReelsRound[] = [];
	protected _fsRounds: ServerAvalancheReelsRound[] = [];

	constructor() {
		this._data = new ServerData();
		this._cheats = new ServerCheats();
		this._cheats.reset();

		(window as any).cheats = this._cheats;
	}

	public init(choosenFeatures: ServerGameFeatures[]): void {
		for (const feature of choosenFeatures) {
			this._data.activateFeature(feature);
		}
	}

	public spin(): void {
		this._cheats.reset();
		if ((window as any).cheat) {
			this._cheats.isCheatsEnabled = true;
			if ((window as any).cheat === 'noCheat') {
				this._cheats.isCheatsEnabled = false;
				this._cheats.reset();
			}
			if ((window as any).cheat === 'simpleWin') {
				this._cheats.cheatPositions = [0, 0, 0, 0, 0, 0];
			}
			if ((window as any).cheat === 'tmpCheat') {
				this._cheats.cheatPositions = [29, 94, 56, 0, 53, 8];
				this._cheats.firstThreeReelsCombination = [0, 1, 2];
				this._cheats.secondThreeReelsCombination = [3, 4, 5];
				this._cheats.expandedWildReels = [5];
			}
			if ((window as any).cheat === 'simpleEW1ReelWin') {
				this._cheats.cheatPositions = [0, 0, 0, 0, 0, 0];
				this._cheats.firstThreeReelsCombination = [0, 1, 2];
				this._cheats.secondThreeReelsCombination = [3, 4, 5];
				this._cheats.expandedWildReels = [0];
			}
			if ((window as any).cheat === 'simpleRespin') {
				this._cheats.cheatPositions = [0, 0, 0, 0, 0, 0];
				this._cheats.firstThreeReelsCombination = [0, 1, 2];
				this._cheats.secondThreeReelsCombination = [3, 4, 5];
			}
			if ((window as any).cheat === 'addChestEW') {
				this._cheats.shouldAddChest = true;
				this._cheats.shouldNOTWinMimicFS = true;
				this._cheats.chestContent.hasExpandedWild = true;
			}
			if ((window as any).cheat === 'addChestExpl') {
				this._cheats.shouldAddChest = true;
				this._cheats.shouldNOTWinMimicFS = true;
				this._cheats.chestContent.hasExplotion = true;
			}
			if ((window as any).cheat === 'addChestRespin') {
				this._cheats.shouldAddChest = true;
				this._cheats.shouldNOTWinMimicFS = true;
				this._cheats.chestContent.hasRespin = true;
			}
			if ((window as any).cheat === 'replayLastRound') {
				if (this._lastRound) {
					return ;
				}
			}
			if ((window as any).cheat === 'simpleChest') {
				this._cheats.shouldAddChest = true;
			}
			if ((window as any).cheat === 'winMimic') {
				this._cheats.shouldAddChest = true;
				this._cheats.chestContent.hasMimicFreeSpins = true;
			}
			if ((window as any).cheat === 'triggerBattleFS') {
				this._cheats.shouldTriggerBattleFreeSpins = true;
			}

		}

		this._lastRound = new ServerAvalancheReelsRound();
		this._lastRound.spin(this._data, this._cheats);

		if (this._data.isInMimicFreeSpins) {
			this._cheats.isCheatsEnabled = false;
			this._mfsRounds = [];
			while (this._data.isInMimicFreeSpins) {
				const round: ServerAvalancheReelsRound = new ServerAvalancheReelsRound();
				round.spin(this._data, this._cheats);

				this._mfsRounds.push(round);
			}
		} else {
			this._mfsRounds = [];
		}

		if (this._data.isInFreeSpins) {
			this._cheats.isCheatsEnabled = false;
			this._fsRounds = [];
			while (this._data.isInFreeSpins) {
				const round: ServerAvalancheReelsRound = new ServerAvalancheReelsRound();
				round.spin(this._data, this._cheats);
				// this._data.addToTotalFreeSpins(round.additionalFSInThisRound);

				this._fsRounds.push(round);
			}
		} else {
			this._fsRounds = [];
		}

		this._history.push(this._lastRound);

		this._cheats.reset();
	}

	public getCurrentRoundResult(): JSON {
		return this._lastRound.getCurrentRoundResult();
	}

	public getCurrentMimicFS(): JSON[] {
		if (!this._mfsRounds) {
			return null;
		}

		const rounds: JSON[] = []
		for (const round of this._mfsRounds) {
			rounds.push(round.getCurrentRoundResult());
		}

		return rounds;
	}

	public getCurrentFS(): JSON[] {
		if (!this._fsRounds) {
			return null;
		}

		const rounds: JSON[] = []
		for (const round of this._fsRounds) {
			rounds.push(round.getCurrentRoundResult());
		}

		return rounds;
	}

	public hasMimicFSRounds(): boolean {
		return this._mfsRounds && this._mfsRounds.length > 0;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/prototype/src/Server.ts